export default __webpack_public_path__ + "static/char-v-47-686f3962055dea43bd1278e43d885ed1.png";